import { Grid } from "@mui/material";
import React, { memo } from "react";
import { ContentOverlay, ContentOverlayProps } from "./components/ContentOverlay";

interface MxOverlayLoadingProps extends ContentOverlayProps {
  children: React.ReactNode;
  loading?: boolean;
  static?: boolean;
}
const MxOverlayLoading = (props: MxOverlayLoadingProps) => {
  const { children, messages, mode = "auto" } = props;

  return (
    <Grid container position="relative" mb={2}>
      <Grid item xs={12}>
        {children}
      </Grid>
      {props.loading && (
        <ContentOverlay
          time={props.time}
          messages={mode == "auto" ? messages : []}
          id={props.id || "overlay"}
          mode={mode}
          top={props.top}
          static={props.static}
        />
      )}
    </Grid>
  );
};

export default memo(MxOverlayLoading);
